<template>
  <div class="card data-table-card">
    <div class="data-table-card__header">
      <h2 
        class="mt-0" 
        data-testId="data-table-card-heading"
      >
        {{ cardHeading }}
        <svg-icon 
          class="data-table-card__icon" 
          :style="{ fill: iconColor }" 
          :icon="headingIcon" 
          data-testId="data-table-card-icon" 
        />
      </h2>
      <div class="data-table-card__btns">
        <f-button 
          v-for="(button, index) in buttonsData" 
          :key="button.text" 
          class="data-table-card__btn" 
          :class="{'btn--primary-alt': button.isActive}" 
          :text="button.text" 
          :data-testId="'data-table-card-button-'+index" 
          @clicked="toggleActiveState(index)" 
        />
      </div>
    </div>
    <remote-data-table 
      :endpoint-url="endpointUrl"
      :columns="gridColumns"
      :initial-sort="initialSort"
      :initial-page-size="initialPageSize"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
export default defineComponent({
  name: "RemoteDataTableCard",
  props:{
    cardHeading:{
      type: String,
      default: ""
    },
    headingIcon:{
      type: String,
      default: "",
    },
    iconColor:{
      type: String,
      default: "#444"
    },
    toggleButtons:{
      type: Array,
      default: () => ([]),
    },
    endpointUrl:{
      required: true,
      type: String
    },
    columns:{
      required: true,
      type: Array
    },
    initialSort:{
      type: Object,
      default: () => ({ dataId: "", direction: "" }),
    },
    initialPageSize:{
      type: Number,
      default: 10
    }
  },
  setup(props) {
    const buttonsData = ref(props.toggleButtons);
    const activeIndex = ref(0);
    const gridColumns = ref(props.columns[0]);

    const toggleActiveState = (index) => {
      for(let i = 0; i < buttonsData.value.length; i++) {
        buttonsData.value[i].isActive = false;
      }
      activeIndex.value = index;
      buttonsData.value[index].isActive = true;
      gridColumns.value = props.columns[index];
    };

    return {
      toggleActiveState,
      buttonsData,
      activeIndex,
      gridColumns
    };
  },
});
</script>

<style lang="scss" scoped>

.data-table-card{
  &__header{
    display: flex;
    flex-direction: column;

    @media(min-width: 540px){
      justify-content: space-between;
      flex-direction: row;
      align-items: center;
    }
  }

  &__icon{
    width: 20px;
    height: 30px;
    margin-left: 8px;
  }

  &__btns{
    margin-bottom: 16px;
  }

  &__btn{
    margin-left: 16px;

    &:first-of-type{
      margin-left: 0;
    }
  }

  :deep(.data-grid_footer){
    overflow: auto;
  }
}
</style>

